import { MOKA_MATCH_RESPONSE_DELAY_MAXIMUM_MS, MOKA_MATCH_RESPONSE_DELAY_MINIMUM_MS } from "@/constants";
const waitForMokaResponseDelay = () => new Promise(resolve => {
  const delayRangeMs = MOKA_MATCH_RESPONSE_DELAY_MAXIMUM_MS - MOKA_MATCH_RESPONSE_DELAY_MINIMUM_MS;
  const delayMs = MOKA_MATCH_RESPONSE_DELAY_MINIMUM_MS + Math.random() * delayRangeMs;

  // HACK: A short delay makes browser-fast inference perceptible as an opponent move.
  window.setTimeout(resolve, delayMs);
});
export { waitForMokaResponseDelay };